// Permissions' registration: the window `permissions` and Home's Permissions item.
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'

registerWindow('permissions', { module: () => import('./permissions.js'), css: 'windows/permissions/permissions.css', key: (a, key) => 'permissions-' + (key || 'mac'), title: () => 'Permissions', place: ['home', 'trailing'] })
registerHomeItem({ id: 'permissions', label: 'Permissions', symbol: 'hand.raised', needs: 'paired', section: 'toolbar', order: 50 })
